<template>
	<div>
		<AgencyProjectsTable/>
	</div>
</template>

<script>

	import AgencyProjectsTable from "./components/AgencyProjectsTable";

	export default {
		name: "UserSupervisedAgencyProjectsList",
		components: {AgencyProjectsTable},

		data: function () {
			return {
				projects: []
			};
		}
	};
</script>

<style scoped>

</style>
